module.exports = __webpack_public_path__ + "img/search-bar-icon.f79259df.svg";